module.exports = __webpack_public_path__ + "b6b5984b31a1096d03576afe6c8c230a.svg";